module.exports = __webpack_public_path__ + "img/logo.c3fba084.svg";